import React, { FunctionComponent } from 'react';

import { Breadcrumbs as BreadcrumbsType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import { graphql } from 'gatsby';

import BreadcrumbsComponent from '../../Breadcrumbs';

export const BreadcrumbsFragment = graphql`
  fragment BreadcrumbsFragment on SanityBreadcrumbs {
    variant {
      variant
    }
    breadcrumbs {
      short_name
      slug {
        current
      }
    }
  }
`;

const Breadcrumbs: FunctionComponent<BreadcrumbsType> = (props) => {
  const { breadcrumbs = [], title } = props;

  const items = breadcrumbs.map((crumb) => ({ label: crumb.short_name, to: crumb.slug?.current }));

  return (
    <Flex margin={{ xs: [2, 4, 0], md: [2, 8, 0] }} width="100%">
      <BreadcrumbsComponent items={[...items, { label: title }]} />
    </Flex>
  );
};

export default Breadcrumbs;
